// simgeler.js — UYGULAMANIN SİMGELERİ — TEK KAYNAK (1 Eki 2026)
//
// 🔑 Serkan (1 Eki 2026): *"nokta kare daire gibi değil, mantıklı imajlar bul"* → *"simgeler tamam"* · indirme izni: *"indir"*.
// Kaynak: Tabler Icons 3.48.0 (outline), unpkg.com/@tabler/icons — yalnız çizim yolları alındı, paket EKLENMEDİ;
//    uygulama çalışırken internetten hiçbir şey yüklenmez. Yeni simge gerekirse BURAYA eklenir (ikinci bir kaynak yok).
//
// Lisans (MIT):
//   MIT License
//
//   Copyright (c) 2020-2026 Paweł Kuna
//
//   Permission is hereby granted, free of charge, to any person obtaining a copy
//   of this software and associated documentation files (the "Software"), to deal
//   in the Software without restriction, including without limitation the rights
//   to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
//   copies of the Software, and to permit persons to whom the Software is
//   furnished to do so, subject to the following conditions:
//
//   The above copyright notice and this permission notice shall be included in all
//   copies or substantial portions of the Software.
//
//   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
//   IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
//   FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
//   AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
//   LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
//   OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
//   SOFTWARE.
import React from 'react';

export const SIMGE_YOLLARI = {
  'archive': ["M3 6a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2", "M5 8v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-10", "M10 12l4 0"],
  'calculator': ["M4 5a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2l0 -14", "M8 8a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1l0 -1", "M8 14l0 .01", "M12 14l0 .01", "M16 14l0 .01", "M8 17l0 .01", "M12 17l0 .01", "M16 17l0 .01"],
  'calendar-time': ["M11.795 21h-6.795a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4", "M14 18a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "M15 3v4", "M7 3v4", "M3 11h16", "M18 16.496v1.504l1 1"],
  'chart-bar': ["M3 13a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1l0 -6", "M15 9a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1l0 -10", "M9 5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1l0 -14", "M4 20h14"],
  'file-pencil': ["M14 3v4a1 1 0 0 0 1 1h4", "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2", "M10 18l5 -5a1.414 1.414 0 0 0 -2 -2l-5 5v2h2"],
  'help': ["M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "M12 17l0 .01", "M12 13.5a1.5 1.5 0 0 1 1 -1.5a2.6 2.6 0 1 0 -3 -4"],
  'notebook': ["M6 4h11a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-11a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1m3 0v18", "M13 8l2 0", "M13 12l2 0"],
  'plane-departure': ["M14.639 10.258l4.83 -1.294a2 2 0 1 1 1.035 3.863l-14.489 3.883l-4.45 -5.02l2.897 -.776l2.45 1.414l2.897 -.776l-3.743 -6.244l2.898 -.777l5.675 5.727", "M3 21h18"],
  'plane': ["M16 10h4a2 2 0 0 1 0 4h-4l-4 7h-3l2 -7h-4l-2 2h-3l2 -4l-2 -4h3l2 2h4l-2 -7h3l4 7"],
  'shield-check': ["M11.46 20.846a12 12 0 0 1 -7.96 -14.846a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 -.09 7.06", "M15 19l2 2l4 -4"],
  'users': ["M5 7a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2", "M16 3.13a4 4 0 0 1 0 7.75", "M21 21v-2a4 4 0 0 0 -3 -3.85"],
};

/** <Simge ad="plane" boyut={18} /> — renk çevreden (currentColor) gelir. */
export default function Simge({ ad, boyut = 18, kalinlik = 2, style, ...rest }) {
  const yollar = SIMGE_YOLLARI[ad];
  if (!yollar) return null;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={boyut} height={boyut} viewBox="0 0 24 24" fill="none"
         stroke="currentColor" strokeWidth={kalinlik} strokeLinecap="round" strokeLinejoin="round"
         aria-hidden="true" focusable="false" style={{ flexShrink: 0, ...style }} {...rest}>
      {yollar.map((d, i) => <path key={i} d={d} />)}
    </svg>
  );
}
